<script lang="ts">
	import { Background } from "@components/Background.js";
	import ContactForm from "@components/ContactForm.svelte";
	import Ol from "@components/Ol.svelte";
	import { OlSize } from "@components/OlProps.js";
	import Section from "@components/Section.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import Layout from "@components/layout/Layout.svelte";
	import arrowNext from "@core/assets/icons/arrow-next.svg?raw";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getConnectWithFastestBenefits } from "../data/getConnectWithFastestBenefits.js";
	import type { ConnectWithFastestProps } from "./ConnectWithFastestProps.js";

	const { tenant } = getGlobalTemplateProps();
	const _: ConnectWithFastestProps = $props();
	const anchorForm = "form";
</script>

<Layout>
	<Section background={Background.LightGradient} centered gridHeadline="container-6" gridDesc="container-6" hero>
		{#snippet headline()}
			<Formatted text="Napište si o cg[[konzultaci zdarma]], nebo se jen tak zeptejte" />
		{/snippet}
		{#snippet desc()}
			<p>
				<Formatted
					text="Potřebuje pomoci s vývojem softwaru, případně s jiným IT projektem? sp[[Vyplňte formulář níže a my se co nejdřív ozveme zpět]]. Buď vám odpovíme na zaslané otázky, nebo si s vámi rovnou domluvíme bezplatnou online schůzku."
				/>
			</p>
		{/snippet}
		{#snippet cta()}
			<Link
				variant={ButtonVariant.PhloxOutlineLightBg}
				class="flex items-center justify-center mx-auto mt-2"
				href="#{anchorForm}"
			>
				<Formatted text="Přejít na formulář" />
				<Icon icon={arrowNext} class="ml-2.5 text-fstgrey-900 w-5"></Icon>
			</Link>
		{/snippet}
	</Section>

	<Section
		centered
		gridHeadline="container-6"
		gridDesc="row-start-3 xl:row-start-auto container-12 md:container-8 xl:container-start-2 xl:container-end-6 !mt-12 xl:!mt-0"
		gridChildren="container-12 md:container-8 xl:container-start-8 xl:container-end-11"
	>
		{#snippet headline()}
			<Formatted text="Proč se do toho pustit s námi?" />
		{/snippet}
		{#snippet desc()}
			<ContactForm id={anchorForm} class="scroll-mt-10 sm:scroll-mt-[11.5rem]" />
		{/snippet}
		<div class="flex flex-col gap-8 text-left">
			<Ol items={getConnectWithFastestBenefits(tenant)} size={OlSize.Medium} />
		</div>
	</Section>
</Layout>
